import { SET_DRAFT_CEILING_HEIGHT } from '../../actionConstants';
import { CEILING_HEIGHT } from '../draftKeys';
import { iCeilingHeight } from './CeilingHeightDataTypes';

export default {
  [SET_DRAFT_CEILING_HEIGHT]: (state: iCeilingHeight, action: any) => ({
    ...state,
    [CEILING_HEIGHT]: action.payload.value,
  }),
};
